import { useSelector } from 'react-redux';

import { WebsiteMockup } from '~/components/atoms/mockup-previews/WebsiteMockup';
import { getWebsiteReducer } from '~/store/reducers/previewScreens/website/selectors';

export function WebsitePreviewScreen() {
  const { websiteInformation } = useSelector(getWebsiteReducer);

  return <WebsiteMockup url={websiteInformation} />;
}
